<template>
<div>
	<div class="d-flex flex-wrap justify-content-between align-items-center">
		<div class="d-flex flex-wrap mb-2">
			<info-box label="Total Revenue" :value="'$' +renderedReport.totalRevenue" class="info-box"></info-box>
			<info-box label="Total Expenses" :value="'$' +renderedReport.totalExpenses" class="info-box"></info-box>
			<info-box label="Total Labour" :value="'$' +renderedReport.totalLabour" class="info-box"></info-box>
			<info-box label="Total Actual Costs" :value="'$' +renderedReport.totalActualCosts" class="info-box"></info-box>
		</div>
		<div>
			<field label="Period"
				col-class="col-auto"
				:params="{type:'select',options: [
					{text: 'Project Lifespan',value:'project-lifespan'},
					{text: 'Last 12 Months',value:'last-12-months'},
					{text: 'Last 6 Months',value:'last-6-months'},
					{text: 'Last 3 Months',value:'last-3-months'}
				]}"
				v-model="reportPeriod"
				v-on:change="periodChange">
			</field>
		</div>
	</div>
	<a href="#" v-on:click.prevent="$emit('chartClick')">
	<chart v-if="renderGraph"
		type="line"
		height="300" 
		:datasets="renderedReport.datasets"
		:labels="renderedReport.labels"
		:options="options"
		v-on:click="$emit('chartClick')">		
	</chart>
	</a>
	<p v-if="!renderGraph" class="text-center" style="border:1px solid #e0e0e0">No data</p>
</div>
</template>
<script type="text/javascript">
import Chart from "@/components/Chart"
import InfoBox from "@/components/InfoBox"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import Field from "@/components/Field"

export default {
	name: "ProjectRevenueGraph",
	components: {
		Chart,
		InfoBox,
		Field
	},
	mixins: [InvoiceMixins],
	props: ["project"],
	data() {
		return {
			invoices: [],
			reportRecords: [],
			renderedReport: {
				totalRevenue: "0.00",
				totalLabour: "0.00",
				totalExpenses: "0.00",
				totalActualCosts: "0.00",
				datasets: []
			},
			renderGraph: false,
			reportPeriod: "project-lifespan",
			selectedDateRange: {
				from_year: 2020,
				from_month: 1,
				to_year: 2020,
				to_month: 12
			}
		}
	},
	watch: {
		project() {
			if (this.project && "id" in this.project) {
				this.fetchReportRange(
					this.dateStart.format("YYYY"),
					this.dateStart.format("M"),
					this.dateEnd.format("YYYY"),
					this.dateEnd.format("M"),
					this.project.id
				)
			}
		}
	},
	computed: {
		options() {
			return {
				tooltips: {
					callbacks: {
						label(item,data) {
							let value = +item.value

							return "$ " + value.toCurrency()
						}
					}
					
				},
				scales: {
					yAxes: [{
						ticks: {
							callback(value,index,values) {
								return '$ '+ value.toCurrency()
							}
						}
					}]
				}
			}
		},
		dateStart() {
			if (this.reportPeriod == "project-lifespan") 
				return this.moment(this.project.date_landed)
			else if (this.reportPeriod == "last-12-months")
				return this.moment().subtract(12,"months")
			else if (this.reportPeriod == "last-6-months")
				return this.moment().subtract(6,"months")
			else if (this.reportPeriod == "last-3-months")
				return this.moment().subtract(3,"months")
		},
		dateEnd() {
			let dateEnd
			if (this.reportPeriod == "project-lifespan") {
				dateEnd = this.moment()
				if (this.project.date_completed)
					dateEnd = this.moment(this.project.date_completed)
			}
			else
				dateEnd = this.moment()

			return dateEnd
		},
	},
	methods: {
		periodChange(value) {
			let vm = this
			this.$nextTick(() => {
				vm.fetchReportRange(
					vm.dateStart.format("YYYY"),
					vm.dateStart.format("M"),
					vm.dateEnd.format("YYYY"),
					vm.dateEnd.format("M"),
					vm.project.id
				)
			})
		},
		renderReport(reportRecords) {
			let vm = this
			let revenue = [], expenses = [], labour = [], actualCosts = [], changeOrderValue = [], labels = []
			let cumulativeRevenue = 0, cumulativeExpenses = 0, cumulativeLabour = 0, totalActualCosts = 0

			if (reportRecords) {
				reportRecords.forEach(record => {
					let datapoints = {}
					try {
						datapoints = JSON.parse(record.report_json)
					}
					catch (e) {}

					if ("revenue" in datapoints) 
						cumulativeRevenue += +datapoints.revenue

					revenue.push(cumulativeRevenue)
					
					if ("expenses" in datapoints) 
						cumulativeExpenses += +datapoints.expenses

					expenses.push(cumulativeExpenses)
						
					if ("labour" in datapoints) 
						cumulativeLabour += +datapoints.labour

					if (+datapoints.cumulative_actual_costs > 0)
						totalActualCosts = +datapoints.cumulative_actual_costs
					
					actualCosts.push(totalActualCosts)

					labour.push(cumulativeLabour)

					labels.push(vm.moment(record.date).format("MMM YYYY"))

				})

				this.renderedReport = {
					totalRevenue: cumulativeRevenue.toCurrency(),
					totalLabour: cumulativeLabour.toCurrency(),
					totalExpenses: cumulativeExpenses.toCurrency(),
					totalActualCosts: totalActualCosts.toCurrency(),
					datasets: [
						{
							label: 'Gross Revenue',
							lineTension: 0,
							borderColor: '#ECBA00',
							fill: false,
							data: revenue
						},
						{
							label: 'Labour',
							lineTension: 0,
							borderColor: 'blue',
							fill: false,
							data: labour
						},
						{
							label: 'Expenses',
							lineTension: 0,
							borderColor: 'red',
							fill: false,
							data: expenses
						},
						{
							label: 'Actual Costs',
							lineTension: 0,
							borderColor: 'purple',
							fill: false,
							data: actualCosts
						},
						/*
						{
							label: 'Change Order Value',
							lineTension: 0,
							borderColor: 'pink',
							fill: false,
							data: changeOrderValue
						}
						*/
					],
					labels 
				}
			}
			else {
				this.renderedReport = {
					totalRevenue: "0.00",
					totalLabour: "0.00",
					totalExpenses: "0.00",
					totalActualCosts: "0.00",
					datasets: []
				}
			}
		},
		fetchReportRange(from_year,from_month,to_year,to_month,job_id) {
			let vm = this

			let params = {
				from_year,
				from_month,
				to_year,
				to_month,
				job_id,
				report_type: "revenue-expenses-monthly"
			}

			this.renderGraph = false

			this.getJSON("JobReport/get-range",params).then(response => {
				if (response.success) {
					vm.reportRecords = response.data

					vm.renderReport(response.data)

					vm.renderGraph = true
				}
			})
		}
	},
	created() {
		let vm = this

		if (this.project && "id" in this.project && this.project.id && !this.isFreemiumUser) {
			this.fetchReportRange(
				this.dateStart.format("YYYY"),
				this.dateStart.format("M"),
				this.dateEnd.format("YYYY"),
				this.dateEnd.format("M"),
				this.project.id
			)
		}
	}
}
</script>

<style scoped>
	.info-box {
		flex-grow: 1
	}
</style>